<app-auth-header
  [title]="'pages.auth.twoFactor.title' | transloco"
  [subtitle]="
    method() === 'totp'
      ? ('pages.auth.twoFactor.totpSubtitle' | transloco)
      : method() === 'webauthn'
        ? ('pages.auth.twoFactor.securityKeySubtitle' | transloco)
        : ('pages.auth.twoFactor.backupSubtitle' | transloco)
  " />

@if (method() === 'totp') {
  <app-auth-panel class="items-center pt-8">
    <app-code-entry
      [step]="step"
      [messages]="messages()"
      [ariaLabel]="'pages.auth.twoFactor.totpLabel' | transloco"
      (completed)="submitTotp($event)" />
  </app-auth-panel>
} @else if (method() === 'webauthn') {
  <app-auth-panel>
    @if (messages().length) {
      <app-kratos-messages [messages]="messages()" />
    }
    <vx-button
      size="lg"
      [fullWidth]="true"
      [loading]="step.busy()"
      (click)="useSecurityKey()">
      {{ 'pages.auth.twoFactor.securityKey' | transloco }}
    </vx-button>
  </app-auth-panel>
} @else {
  <form [formGroup]="backupForm" (ngSubmit)="submitBackupCode()" novalidate>
    <app-auth-panel>
      <vx-form-field [label]="'pages.auth.twoFactor.backupLabel' | transloco">
        <vx-input
          size="lg"
          name="lookup_secret"
          autocomplete="one-time-code"
          formControlName="code" />
      </vx-form-field>

      @if (messages().length) {
        <app-kratos-messages [messages]="messages()" />
      }

      <vx-button
        type="submit"
        size="lg"
        [fullWidth]="true"
        [loading]="step.busy()">
        {{ 'pages.auth.twoFactor.verify' | transloco }}
      </vx-button>
    </app-auth-panel>
  </form>
}

@if (failed()) {
  <p class="mt-4 text-13 tracking-tight text-danger-400" role="alert">
    {{ 'pages.auth.twoFactor.failed' | transloco }}
    <button
      type="button"
      class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      [disabled]="step.busy()"
      (click)="restart()">
      {{ 'pages.auth.twoFactor.retry' | transloco }}
    </button>
  </p>
}

@if (offersSecurityKey() && method() !== 'webauthn') {
  <vx-button
    class="mt-4"
    variant="outline"
    size="lg"
    [fullWidth]="true"
    [disabled]="step.busy()"
    (click)="useSecurityKey()">
    {{ 'pages.auth.twoFactor.securityKey' | transloco }}
  </vx-button>
}

@if (method() !== 'lookup_secret' && offersBackupCode()) {
  <p class="mt-5 text-center text-13 tracking-tight text-zinc-400">
    @if (method() === 'totp') {
      {{ 'pages.auth.twoFactor.lostDevice' | transloco }}
    } @else {
      {{ 'pages.auth.twoFactor.noSecurityKey' | transloco }}
    }
    <button
      type="button"
      class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      (click)="switchMethod('lookup_secret')">
      {{ 'pages.auth.twoFactor.useBackupCode' | transloco }}
    </button>
  </p>
} @else if (method() === 'lookup_secret' && offersTotp()) {
  <p class="mt-5 text-center text-13 tracking-tight text-zinc-400">
    <button
      type="button"
      class="text-zinc-200 underline underline-offset-2 hover:text-zinc-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50"
      (click)="switchMethod('totp')">
      {{ 'pages.auth.twoFactor.useApp' | transloco }}
    </button>
  </p>
}
